import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Slider from "@mui/material/Slider";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import { useEffect, useState } from "react";
import { setZoomFactor } from "./Functions/FunctionsMain";
import { useSelector } from "react-redux";
import { RootState } from "../..";

export function ZoomSlider() {
  const zoomFactor = useSelector((state: RootState) => state.examBuilder.main.zoomFactor);
  const [screenHeight, setScreenHeight] = useState(0);

  useEffect(() => {
    const updateHeight = () => setScreenHeight(window.innerHeight);
    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  const handleChange = (event: Event, newValue: number | number[]) => {
    if (typeof newValue === "number") {
      const newValueInDecimals = newValue / 100;
      setZoomFactor(newValueInDecimals);
    }
  };

  return (
    <Box sx={{ width: 300, position: "fixed", top: `${screenHeight - 40}px`, left: "72px", zIndex: "4" }}>
      <Stack spacing={2} direction="row" sx={{ alignItems: "center", mb: 1 }}>
        <ZoomOutIcon />
        <Slider aria-label="Zoom" value={zoomFactor * 100} onChange={handleChange} min={20} max={50} />
        <ZoomInIcon />
      </Stack>
    </Box>
  );
}
